import { __assign } from "tslib";
import { isConditionalType, isConditionalValidation, } from '../types';
import { resolveUseSamePath } from './resolveUseSamePath';
export function nestedResolveUseSamePath(conditions, currentFieldPath) {
    if (conditions === null || conditions === void 0 ? void 0 : conditions.length) {
        return conditions.map(function (item) {
            if (isConditionalType(item)) {
                var updatedFieldName = item.fieldName;
                if (item.useSamePath) {
                    updatedFieldName = resolveUseSamePath(currentFieldPath, item.fieldName);
                }
                return __assign(__assign({}, item), { fieldName: updatedFieldName });
            }
            if (isConditionalValidation(item) && item.conditions) {
                return __assign(__assign({}, item), { conditions: nestedResolveUseSamePath(item.conditions, currentFieldPath) });
            }
            return __assign({}, item);
        });
    }
    return [];
}
